import React from 'react';

const Resume = () => {
  return (
    <>
    <div style={{ width: '100%', height: '100vh' }}>        
      <iframe
        src="assets/cv/jameskalu.pdf"
        width="100%"
        height="100%"
        title="Portfolio PDF"
      ></iframe>
    </div>
    </>
  );
};

export default Resume;